import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dropdown, Avatar, Badge } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import classNames from 'classnames'

import { logout as confirmLogout } from 'utils/ui'
import Settings from 'components/cleanui/layout/TopBar/Settings'
import ProfilePhoto from 'components/ProfilePhoto'
import { getInitialAvatar } from 'pages/chat/component/chatView/data/cUtil'

import styles from './style.module.scss'

const mapStateToProps = ({ user }) => ({ user })

const ProfileMenu = ({ user }) => {
  const { t } = useTranslation()
  const [count, setCount] = useState(0)
  const [settingsOpen, setSettingsOpen] = useState(false)

  const logout = (e) => {
    confirmLogout()

    e.preventDefault()
  }

  const addCount = () => {
    setCount(0)
  }

  const handleSettingsClick = (e) => {
    setSettingsOpen(!settingsOpen)

    e.preventDefault()
  }

  const items = [
    {
      label: (
        <button
          type="button"
          className={classNames('settingsButton', styles.settingsButton)}
          onClick={handleSettingsClick}
        >
          {t('common.button.settings')}
        </button>
      ),
      key: 'settings',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <a href="#" onClick={logout} className="menu-logout">
          {/* <i className="fe fe-log-out mr-2" /> */}
          {t('topBar.profileMenu.logout')}
        </a>
      ),
      key: 'logout',
    },
  ]

  // const menu = <Menu selectable={false} items={items} />
  const menu = {
    items,
    selectable: false,
  }

  let avatarElem = null
  if (user == null) {
    avatarElem = <UserOutlined />
  } else if (user.avatar == null || user.avatar.trim().length === 0) {
    avatarElem = getInitialAvatar(user.name, user.email)
  } else {
    avatarElem = <ProfilePhoto className="avatar-img" url={user.avatar} displayName={user.name} />
  }

  const clsProps = {
    menu,
    trigger: ['click'],
    onOpenChange: addCount,
    overlayClassName: classNames(styles.userMenu, 'floatingSubMenu'),
    width: 160,
  }

  return (
    <React.Fragment>
      <Dropdown {...clsProps}>
        <div className={styles.dropdown}>
          <Badge count={count}>
            <Avatar
              src={user.avatar}
              className={styles.avatar}
              shape="circle"
              size={32}
              icon={avatarElem}
            />
          </Badge>
        </div>
      </Dropdown>
      <Settings open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </React.Fragment>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
